import { Fragment, useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import { abpnClient } from '../../Services/AbpnClient';
import { configService } from '../../Services/Config/ConfigService';
import AvailableExaminationCard from '../Dashboard/Applications/Components/AvailableExaminationCard';
import { AvailableExamination } from '../Dashboard/Applications/Models/AvailableExamination';
import AbpnSpinner from '../Shared/Components/AbpnSpinner';
import { getDateWithOffset } from '../Shared/Utility/GetDateWithOffset';
import SearchPhysicianModel from './Models/SearchPhysicianModel';

interface IProps {
	searchModel: SearchPhysicianModel;
	reportNoExams: () => void;
}
const ActivationSelectExam = (props: IProps) => {
	const [ availableExams, setAvailableExams ] = useState<AvailableExamination[]>([]);
	const [ loading, setLoading ] = useState<boolean>(true);
	const [ noExamsAvailable, setNoExamsAvailable ] = useState<boolean>(false);
	const [mailToLink, setMailToLink] = useState<string>(null);

	useEffect(() => {
		const getMailToLink = () => {
			configService.getConfiguration().then(_ => {
				setMailToLink(_.PhysicianPortalHelp);
			})
		}
		getMailToLink();

		abpnClient.get<Array<AvailableExamination>>('/api/application/available', null).then((exams) => {
			setAvailableExams(exams);
			setLoading(false);

			var hasNoExams = exams.filter((_) => getDateWithOffset(_.applicationAvailableDate) <= new Date()).length === 0;
			setNoExamsAvailable(hasNoExams);
			if (hasNoExams) props.reportNoExams();
		});
	}, []);

	if (loading) return <AbpnSpinner />;

	return (
		<Fragment>
			{noExamsAvailable ? (
				<p>
					ABPN Physician Portal account activation cannot occur at this time because applications are
					currently not available. Please return when examination applications become available as noted
					below.
				</p>
			) : (
				<Fragment>
					<p>
						An ABPN examination needs to be requested in order to begin the ABPN Physician Portal account
						activation process.
					</p>
					<p>
						<strong>Do not see your exam here?</strong> Please contact ABPN through email at <a href={mailToLink}>questions@abpn.org</a> with subject "Physician Portal Help” for assistance.
						If you are a diplomate of another ABMS board (not of ABPN) and you would like to apply for an
						ABPN administered subspecialty examination, please apply through your parent board.
					</p>
				</Fragment>
			)}
			<Row>
				{availableExams.map((exam: AvailableExamination) => (
					<Col xl={4}>
						<AvailableExaminationCard
							applyLinkTo={{
								pathname: `/PersonalInformation`,
								state: {
									examinationId: exam.examinationId,
									data: props.searchModel
								}
							}}
							examination={exam}
							currentCCEnrollment={null}
						/>
					</Col>
				))}
			</Row>
		</Fragment>
	);
};

export default ActivationSelectExam;
